import debounce from "lodash.debounce";

export const useScrollToTopDebounce = (): Function => {
  const runtimeConfig = useRuntimeConfig()

  return debounce(() => {
    window?.scrollTo(0, 0)
  }, Number(runtimeConfig.public.scrollToTopDebounce || 100))
}